import script from "./UpsertCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpsertCatalog.vue?vue&type=script&setup=true&lang=js"

import "./UpsertCatalog.vue?vue&type=style&index=0&id=63143048&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63143048"]])

export default __exports__